import Button from "./Button.tsx";
import {MouseEventHandler, useEffect, useState} from "react";

interface InstructionsModalProps {
    onClose: MouseEventHandler<HTMLSpanElement>
    closing: boolean
}

function useLang(): 'zh' | 'en' {
    const [lang, setLang] = useState<'zh' | 'en'>(() => {
        try {
            const saved = localStorage.getItem('games-site-lang');
            if (saved === 'zh' || saved === 'en') return saved;
        } catch (e) {}
        return (navigator.language || 'zh').toLowerCase().indexOf('zh') === 0 ? 'zh' : 'en';
    });
    useEffect(() => {
        const onChange = () => {
            try {
                const saved = localStorage.getItem('games-site-lang');
                if (saved === 'zh' || saved === 'en') setLang(saved);
            } catch (e) {}
        };
        window.addEventListener('games-i18n-change', onChange);
        return () => window.removeEventListener('games-i18n-change', onChange);
    }, []);
    return lang;
}

export default function InstructionsModal({ onClose, closing }: InstructionsModalProps) {
    const lang = useLang();
    const zh = lang === 'zh';
    return (
        <div data-ui-chrome="1" className={`modal-overlay ${closing ? 'closing' : ''}`}>
            <div className="modal">
                <div className="modal-content px-8 py-8 md:max-w-lg mx-4 flex flex-col items-center">
                    <span className="close-button" onClick={onClose}>&times;</span>
                    <h1 className="mt-4 text-3xl">{zh ? '欢迎来到 3072！' : 'Welcome to 3072!'}</h1>
                    <ol className="list-decimal flex flex-col gap-1 ml-2.5 my-6 font-normal text-left">
                        {zh ? (
                            <>
                                <li>使用<b>滑动</b>或<b>方向键</b>移动方块。</li>
                                <li>两个<b>相同</b>数字的方块相撞时，会合并成它们的和！</li>
                                <li>目标是合并方块，创造数字 <b>'3072'</b>。</li>
                                <li>当网格填满且无法进行有效移动时，游戏结束。</li>
                            </>
                        ) : (
                            <>
                                <li><b>Swipe</b> or use <b>arrow keys</b> to move the blocks.</li>
                                <li>When two blocks with the <b>same</b> number touch, they combine to form a block with their sum!</li>
                                <li>The goal is to combine blocks to create a block with the number <b>'3072'</b>.</li>
                                <li>The game is over when the grid is filled and you cannot make a valid move.</li>
                            </>
                        )}
                    </ol>
                    <Button clickFunction={onClose} buttonMessage={zh ? '开始！' : "Let's Go!"}/>
                </div>
            </div>
        </div>
    );
}
